import React, { useEffect, useState } from 'react';
import "./home.css";
import 'aos/dist/aos.css';
import Slider from "../../mainPages/Home/slider/Slider.jsx";
import ServicesPage from '../../components/Services/Services.jsx';
import Blog from "../../components/Blog/Blog.jsx";
import Testimonials from '../About/Testimonials.jsx';
import Projects from '../../components/Projects/Projects.js';
import ProductList from '../../components/gallery/gallery.jsx';
import GoldRateDropdown from "../../components/GoldRateDropdown/GoldRateDropdown";
import SilverRateDropdownComponent from "../../components/SilverRateDropdown/SilverRateDropdown";
import Categories from '../../components/CatogoriesList/Categories.js';




export default function Home() {
  
 

  return (
    <>
      <section className='mobile-only-section' data-aos="fade-up">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="single-line-content">
                <span className="title"></span>
                <GoldRateDropdown />
                <span className="separator"></span>
                <SilverRateDropdownComponent />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Slider />
      <br />
      <Categories />
      <h3 style={{ color: 'black', fontWeight: 'bold',marginTop:'0' }}>Popular Products</h3>
      <section className='shop' data-aos="fade-up">
        <ProductList />
      </section>
      <section> <Blog /></section>

      <section className='service'>
        <ServicesPage />
      </section>

      <section className='review'>
        <Testimonials />
      </section>

      {/* <section className="min-h-screen flex items-center justify-center bg-gray-100" style={{ backgroundColor: 'beige' }}>
        <Projects />
      </section> */}
    </>
  );
}
